const analyticsData = {
  id: process.env.NODE_ENV === 'production' ? 'UA-170279726-1' : 'UA-163632953-1',
};

export default analyticsData;
